import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './router'
import './registerServiceWorker'
import './plugins/basic-components.js'
import api from './api'
import './mixins'
import utils from './utils/index'
// import './utils/interceptors'
import './assets/fonts/iconfont/iconfont.css'
import './styles/index.scss'

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$utils = utils

Vue.use(VueRouter)
const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'hash',
  routes
})

/**
 * 初始化应用
 */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
